// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import crumb from '../crumb';
import Rails from '@rails/ujs';
import { Turbo } from"@hotwired/turbo-rails"
import * as ActiveStorage from '@rails/activestorage';
import '../cookie_consent';
import '../file_inputs';
import '../home_laser';
import '../analytics';
import 'bootstrap.native';

Rails.start();
ActiveStorage.start();

document.addEventListener('turbo:load', function() {
  BSN.initCallback(document.body);

  crumb.drop();
});
